import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useWizardExit from '@swf/core/hooks/useWizardExit';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const useLogout = (): (() => void) => {
  const exitWizard = useWizardExit();
  const { auth } = useDispatch<Dispatch>();
  const isEmbedded = useSelector(select.device.isEmbedded);

  return useCallback(() => {
    if (isEmbedded) {
      window.starsweb?.app?.execute('logout');
      postMessage('close');
      window.close();
    } else {
      exitWizard();
      auth.logout();
    }
  }, [auth, exitWizard, isEmbedded]);
};

export default useLogout;
